"use strict";
/**
 * je treba mit nadefonovane promenne
 *
 * gl_cookie_help_status
 * gl_url_www
 * gl_lang_code
 */

let ready=[];
let resize = [];

// inicializace sticky
window.init_sticky=()=>{
    if ( $('#sticky').length ) {
        $( "<div id=\"sticky-point\"></div>" ).insertBefore( "#sticky" );
    }
    //sticky-top version
    if ( $('#sticky-top').length ) {
        $( "<div id=\"sticky-top-point\"></div>" ).insertBefore( "#sticky-top" );
    }
}
let stickyTO;
window.make_sticky=()=>{
    if ( $('#sticky-point').length ) {
        var original_position_offset = $('#sticky-point').offset();
        var sticky_left = $('#sticky-point').offset().left;
        var sticky_offset = original_position_offset.top;
        var sticky_width = $('#sticky').width();
        var sticky_height = $('#sticky').outerHeight();
        var where_scroll = $(window).scrollTop();
        var window_height = $(window).height();
clearTimeout(stickyTO);
        if((where_scroll + window_height) > sticky_offset) {
            $('#sticky').removeClass('sticky-fixed');
            $('#sticky').addClass('sticky-relative');
            $('#sticky').css('left', '0px');
            $('#sticky').css('width', 'inherit');
            stickyTO = setTimeout(()=>document.querySelector('#sticky-point').style.height='0px', 25);
        }

        if((where_scroll + window_height) < (sticky_offset + sticky_height))  {
            $('#sticky').css('left', sticky_left+'px');
            $('#sticky').css('width', sticky_width+'px');
            $('#sticky').removeClass('sticky-relative');
            $('#sticky').addClass('sticky-fixed');
            document.querySelector('#sticky-point').style.height=document.querySelector('#sticky').offsetHeight+'px';
        }
    }
    //sticky-top version
    if ( $('#sticky-top-point').length ) {
        var original_position_offset = $('#sticky-top-point').offset();
        var sticky_left = $('#sticky-top-point').offset().left;
        var sticky_offset = original_position_offset.top;
        var sticky_width = $('#sticky-top').width();
        var sticky_height = $('#sticky-top').outerHeight();
        var where_scroll = $(window).scrollTop();

        if((where_scroll /*+ window_height*/) < sticky_offset) {
            $('#sticky-top').css('left', '0px');
            $('#sticky-top').css('width', 'inherit');
            $('#sticky-top-point').css('height', '0px');
            $('#sticky-top').removeClass('sticky-top-fixed');
            $('#sticky-top').addClass('sticky-top-relative');
        }

        if((where_scroll /*+ window_height*/) > (sticky_offset + sticky_height))  {
            $('#sticky-top').css('left', sticky_left+'px');
            //$('#sticky-top').css('width', sticky_width+'px');
            $('#sticky-top').removeClass('sticky-top-relative');
            $('#sticky-top').addClass('sticky-top-fixed');
            $('#sticky-top-point').css('height', $('#sticky-top').outerHeight()+'px'); // nelze pouzit promenna, zustava tam dele height z relative
        }
    }
}
ready.push(window.init_sticky);
ready.push(window.make_sticky);

$(window).scroll(function(){
    make_sticky();
});
/*$(window).resize(function(){
    make_sticky();
});*/
resize.push(make_sticky);

// signalizace napovedy // dokouzlení otazníků k inputům ve formu
ready.push(function(){
    let otaznik = '<div class="bs_popover_sign"><span class="icon-lamp8"></span></div>';
    $("textarea.bs_popover").before(otaznik);
    $("input.bs_popover").not(".ui-autocomplete-input").before(otaznik);
});

// inicializace taby
$(document).delegate("#myTab a", 'click', function(e){
    e.preventDefault();
    $(this).tab('show');
});

// vychozi otevreni tabu
// opravit selector, tyvole :) a[href=#neco] není platný selector !!
ready.push(function(){
    var id = (""+(window.location)).split("#");
    if(id.length>1){
        var href = '#'+id[id.length-1];
        var tab = $('.nav.nav-tabs a[href='+href+']');
        if(tab.length>0){
            tab.tab('show');
        }
    }
});

/* Tooltips */
// Popover
window.initPopover=()=>{
    try { $('.bs_popover').popover('destroy'); } catch(e) {}

    // fix - vyparsování cesty k instanci
    // var $userPath = window.gl_url_www.replace(new RegExp('^'+location.origin+'/?'), '').replace(/\/$/, '').replace(/^\//, '/');
    // rsp. proč? prostě pro celý web / hotdog / colddog ...
    var $userPath = '/';
    var $cookieStatus = window.gl_cookie_help_status;
    var popoverPlacement = function(){
        var ret = 'auto';
        try{
            var offset= this.$element.offset();
            var winScrollTop = $(window).scrollTop();
            if(offset.left >280){
                // pokud se vejde doleva
                ret = "left";
            }else if (offset.top > (winScrollTop +100)){
                ret = "top";
            }else{
                ret = "bottom";
            }
        }catch(e){
            console.log("chyba v detekci elementu pro popover position", e);
        }
        return ret;
    }
    var popoverTemplate = '<div class="popover" role="tooltip"><div class="arrow"></div><h3 class="popover-title"></h3><span class="icon-lamp8 popover-title-icon"></span><div class="popover-content"></div></div>';
    // pokud je zapnuto v cookies nebo neexistuje tak inicializuju (po refresh stranky)
    if ( $.cookie($cookieStatus) == 1 || $.cookie($cookieStatus) == null) {
        $('.bs_popover').popover(
            {container: 'body', placement: popoverPlacement,  html: 'true', template: popoverTemplate}
        );
        $.cookie($cookieStatus, 1, { path: $userPath });
    }
    // odstranim click na button
    $("#helpButton").unbind('click');
    // nabinduju novy click, ktery zapina/vypina napovedu
    $("#helpButton").click(function(){
        switch ($.cookie($cookieStatus)) {
            case '0':
                $.cookie($cookieStatus, '1', { path: $userPath });
                $('.bs_popover').popover(
                    {container: 'body', placement: popoverPlacement, html: 'true', template: popoverTemplate});
                //$(this).parents('li').toggleClass('active'); // v dropdown nas zajima jen jediny parent
                //$(this).parent('li').toggleClass('active');
               // $('#napovedaOdkaz').parent('li').toggleClass('active'); // pokud se pouziva modalni okno pro prepnuti
                $('#napovedaOdkaz .text').html(window.jstr('Zakázat nápovědu')); //anglicky to tu nejde, nemam to jak zjistit
                break;
            default:
            case '1':
                $.cookie($cookieStatus, 0, { path: $userPath });
                $('.bs_popover').popover('destroy');
                //$(this).parent('li').toggleClass('active'); // totez co vyse
                //$('#napovedaOdkaz').parent('li').toggleClass('active'); // totez co vyse
                $('#napovedaOdkaz .text').html(window.jstr('Povolit nápovědu')); //anglicky to tu nejde, nemam to jak zjistit
                break;
        }
    });
}
//Init Popover
ready.push(window.initPopover);
ready.push( function () {
    var $cookieStatus = window.gl_cookie_help_status;
    if (!parseInt($.cookie($cookieStatus)||0)) {
        $('#napovedaOdkaz .text').html(window.jstr('Povolit nápovědu'));
    }
    $('#nastaveniNapovedaModal').on('show.bs.modal', function() {
        var $modalWindow = $('#nastaveniNapovedaModal');
        if (!parseInt($.cookie($cookieStatus)||0)) {
            $modalWindow.find('.modal-body').html('<p>'+window.jstr('Zobrazení rozšířené nápovědy u položek formulářů je zakázáno. Chcete jej povolit?')+'</p>');
            $modalWindow.find('.modal-title').html('<span class="icon-bubble-notification" aria-hidden="true"></span> '+window.jstr('Povolit nápovědu'));
            $modalWindow.find('#helpButton').html(window.jstr('Povolit nápovědu'));
        } else {
            $modalWindow.find('.modal-body').html('<p>'+window.jstr('Chcete vypnout zobrazení nápovědy u položek formulářů?</p><p>Pokud budete potřebovat poradit s obsahem některé položky formuláře, můžete si nápovědu na tomto místě opět zapnout.')+'</p>');
            $modalWindow.find('.modal-title').html('<span class="icon-question5" aria-hidden="true"></span> '+window.jstr('Zakázat nápovědu'));
            $modalWindow.find('#helpButton').html(window.jstr('Zakázat nápovědu'));
        }
    })
});

// Tooltip
window.initTTip=()=>{ 
    $('.btn-ttip').tooltip({container: 'body', html:true}); /* trida pro tooltipy tlacitek, je lepsi mit oddelene */
    // doplneni title nad standardnimi tlacitky ve vut item
/* LIGHTHOUSE zabití compact
        if ($.cookie('vut_compact') == 1 ) {
        // title nad aktivnimi tlacitky
        $('.vut-item .btn').not('.disabled').each(function( index ) {
            // nedelat nad tlacitky s caret, obvykle se tam vypisuje nejaky stav
            if ($(this).children('.caret').length == 0) {
                $(this).attr('title', $.trim($(this).text()));
            }
        });
        // uprava title nad disabled tlacitky, resp jejich kontejneru
        $('.vut-item .bs_ttip').each(function( index ) {
            if ($(this).children('.btn.disabled').length>0) {
                $(this).attr('title', $.trim($(this).text()) + ' - ' + $(this).attr('title'));
            }
        });
        $('.vut-item .btn').not('.disabled').addClass('bs_ttip');
    }
*/
    $('body').tooltip({
        container: 'body',
        selector: '.bs_ttip'
    }); /* {container: 'body'} zajistí neskákání btn-group tlačítek s hintama*/
    
}
/* todle by imo mělo přijít do $.document('ready') */
ready.push(initTTip);

// pokus o prepsani title

/* pravděpodobně řešitelné na css úrovni */
// propojeni radio/check -> button
window.check_action_button = function(el, invertovat){
    var checked = el.is(':checked');

    if(invertovat) {
        // vypada ze nova JQ vyresila problem s "invertovanim" hodnot
        // checked = !checked;
    }
    if(checked){
        el.parents('label.btn').addClass("active");
    }else{
        el.parents('label.btn').removeClass("active");
    }
}
ready.push(function(){
    $('form label.btn input[type=checkbox],form label.btn input[type=radio]').each(function(k,v){
        check_action_button($(v), 1);
    });
    $('form').delegate('label.btn input[type=checkbox],label.btn input[type=radio]','click', function(){
        $('label.btn input', $(this).parents('.btn-group') ).each(function(k, v){
            check_action_button($(v), 0);
        } )
    });
});



// date / time picker
window.initDatepicker=()=>
{
    if($.isFunction($('.formDate').datepicker))
    {
        $.datepicker.setDefaults($.datepicker.regional[gl_lang_code]);
        $('.formDate').datepicker({changeYear: true,  dateFormat: 'dd.mm.yy' });
    }
    if($.isFunction($(".formDatetime").datetimepicker))
    {
        var myControl=  {
            create: function(tp_inst, obj, unit, val, min, max, step){
                $('<input class="ui-timepicker-input" value="'+val+'" style="width:50%">')
                    .appendTo(obj)
                    .spinner({
                        min: min,
                        max: max,
                        step: step,
                        change: function(e,ui){ // key events
                            // don't call if api was used and not key press
                            if(e.originalEvent !== undefined)
                                tp_inst._onTimeChange();
                            tp_inst._onSelectHandler();
                        },
                        spin: function(e,ui){ // spin events
                            tp_inst.control.value(tp_inst, obj, unit, ui.value);
                            tp_inst._onTimeChange();
                            tp_inst._onSelectHandler();
                        }
                    });
                return obj;
            },
            options: function(tp_inst, obj, unit, opts, val){
                if(typeof(opts) == 'string' && val !== undefined)
                    return obj.find('.ui-timepicker-input').spinner(opts, val);
                return obj.find('.ui-timepicker-input').spinner(opts);
            },
            value: function(tp_inst, obj, unit, val){
                if(val !== undefined)
                    return obj.find('.ui-timepicker-input').spinner('value', val);
                return obj.find('.ui-timepicker-input').spinner('value');
            }
        };
        $.timepicker.setDefaults($.timepicker.regional[gl_lang_code]);
        $(".formDatetime").datetimepicker({controlType: myControl, stepMinute: 5, hour:12, changeYear: true, dateFormat: 'dd.mm.yy' });
        //$(".formDatetime").datetimepicker({controlType: myControl});

    }
}
ready.push(window.initDatepicker);

/* nove menu  */
/* 2022 - přidáno return false - otvíralo to hash v teacheru a stránka skočila nagoru
   + upřesněn selektor z '.extendable a' na '.extendable>a' protože to pak preventovalo i klik na položky */
$( ".extendable>a" ).click(function(){
    // ovladani menu 2 úrovní
    $(this).next('ul').slideToggle(window.VUTResizeHandler?.dispatch);
    $(this).parent().toggleClass('open');
    return false;
});
$('.dropdown.cvis-app-dropdown').on('show.bs.dropdown', function(){
    $('#bg-overlay').fadeIn(100);
})
$('.dropdown.cvis-app-dropdown').on('hide.bs.dropdown', function(){
    $('#bg-overlay').fadeOut(100);
})
/* focus vyhledavani v menu, pokud je dostupne po reloadu
 * nekde mozna toto nebude chtene, ale zatim nevim, kde by to mohlo vadit
 *** já vím -- když je kolapsovaný sidebar ****
 * */
if ((document.querySelector('#menu-hledani'))&&(!document.querySelector('.vut-sidebar-collapsed'))) {
    $('#menu-hledani').focus();
    $('.menu-search').addClass('focus');
}

import {tResponsive} from './mods/tresponsive.js';

window.tResponsive = tResponsive;

// prodlouzeni tabulek podle vychozi sirky
// nereaguje na resize okna, ale to nas asi nezajima
// todo zabít //
window.tableResponsiveInit = function(){
    var e;
    if (e=document.querySelector(".main")) {e.style.overflow="hidden";}
    $(".table-responsive[data-table-max-width]").each(function(){
        if ($(".main").width() > $(this).attr("data-table-max-width")) {
            $(this).width($(this).attr("data-table-max-width"));
            //alert($(this).attr("data-table-max-width"));
        } else {
            $(this).width($(".main").width());
        }
        $(this).trigger('cev_tResponsiveCheck');
    });
    $(".embed-responsive[data-embed-max-width]").each(function(){
        if ($(".main").width() > $(this).attr("data-embed-max-width")) {
            $(this).width($(this).attr("data-embed-max-width"));
        } else {
            $(this).width($(".main").width());
        }
    });
    $(".js-responsive-tabs[data-max-width]").each(function(){
        if ($(".main").width() > $(this).attr("data-max-width")) {
            //$(this).width($(this).attr("data-max-width"));
            //console.log($(this).width());
            //console.log('nazdar');
        } else {
            $(this).width($(".main").width());
            // console.log($(this).width());
        }
    });
    //console.log('nazdar3');
    if (e) {setTimeout(function(){e.style.overflow="";},50);}

};

/* zase chybí ready */
ready.push(window.tableResponsiveInit);

// $( window ).on("resize", tableResponsiveInit);
resize.push(tableResponsiveInit);

ready.push( () => {
    $('.table-responsive').each(function(k, v){
        var tResp = new tResponsive(v);
        tResp.init(); 
        $(v).trigger('cev_tResponsiveCheck');
    });
});

/**
 *respoznivni chovani tabu
 **/
 /* omg todle má vlastní skript dávno */ /*
$(document).ready(function(){
    if($.isFunction($(".js-responsive-tabs").bootstrapResponsiveTabs)) {
        $(".js-responsive-tabs").bootstrapResponsiveTabs({});
    }
}) */

/*
* obsluha uploadu souboru
* */ 

import {FileDecorator} from './mods/file.decorator.js';

ready.push(function(){
    var decor = new FileDecorator(gl_lang_code);
    decor.init();
}) ; 

import {FormMessage} from './mods/form.message'

ready.push(()=>{window.validator = new FormMessage(window.gl_lang_code, '.form-group-required', {})});




$('.table-responsive .dropdown-toggle').click(function(){
    dropDownFixPosition($(this),$(this).next('.dropdown-menu'));
});
$(window).scroll(function(){
    var menu = $('.table-responsive .dropdown-menu:visible');
    var button = menu.prev();
    // reseni dropdown v responsivni tabulce
    if(button.length) {
        dropDownFixPosition(button, menu);
    }
});

window.dropDownFixPosition=(button, dropdown)=>{


    var dropDownTop = button.offset().top + button.outerHeight() - $(document).scrollTop();
    ///console.log(dropDownTop);
    //console.log($(document).scrollTop());
    dropdown.css('top', dropDownTop + "px");
    dropdown.css('left', button.offset().left + "px");

}

window.addEventListener('DOMContentLoaded', ()=>{ready.forEach((fn)=>fn())}, true);
if (window.VUTResizeHandler) {
    resize.forEach((fn)=>VUTResizeHandler.add(fn));
} else {
    $(window).resize(function(){resize.forEach((fn)=>fn())});
}